import { filterNames } from '../constants/filterNames';
import { createDateDefaultValue } from '../constants/common';

export const isDefaultFilter = (search) => {
  const params = new URLSearchParams(search);

  const createDateName = filterNames.createDate;

  if (params.get(createDateName) === createDateDefaultValue.join(',')) {
    params.delete(createDateName);

    return [...params.keys()].length === 0 ? true : false;
  } else {
    return false;
  }
};
